import React from 'react';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import { privateRoutes, publicRoutes } from './router';
import RouteWithSubRoutes from './utils/RoutesWithSubroutes';
import AuthWrapper from './utils/authWrapper';
import { UserContext, useUser } from "./models/user";
import { ConfigProvider } from 'antd';
import Login from './pages/login/login';

import zhCN from 'antd/es/locale/zh_CN';

// import moment from 'moment';
import 'moment/locale/zh-cn';

// import dayjs from 'dayjs';
// import 'dayjs/locale/zh-cn';

// dayjs.locale('zh-cn');

// moment.locale('zh-cn');

function App() {

  const userStore = useUser();

  return (
    <ConfigProvider locale={zhCN}>
      <div className="App">
        <UserContext.Provider value={userStore}>
          <Router>
            <Switch>
              {publicRoutes.map((route, i) => (
                <RouteWithSubRoutes key={i} {...route} />
              ))}
              {privateRoutes.map((route, i) => (
                <AuthWrapper key={i} {...route} RouterComponent={route.component} />
              ))}

              <Route component={Login} />
            </Switch>
          </Router>
        </UserContext.Provider>

      </div>
    </ConfigProvider>
  );
}

export default App;
